import React from 'react';
import classes from './SourceSetupPage.module.scss';
import useSourceSetup from 'new/components/flows/types/elt/CreateELTFlow/SourceSetupPage/useSourceSetup';
import useELT from 'new/components/flows/types/elt/CreateELTFlow/ELTFlow/useELT';
import { ELTSourceSetup } from 'new/components/flows/configure/ELT/ELTSourceSetup';
import { FORM_TYPE_CREATE_ELT } from 'js/constants/formTypes';
import { CustomUserConfirmation } from 'js/components/route_utils/UserConfirmation';

interface SourceSetupPageProps {}

export const SourceSetupPage = (props: SourceSetupPageProps) => {
  const {
    onNameChanged,
    onDescriptionChanged,
    isEditMode,
    isLoadingInitialData,
    // Template version information from useSourceSetup
    templateVersionInfo,
    // Save confirmation state
    showSaveConfirmation,
    handleSaveConfirmation,
    onCloseSaveConfirmation,
  } = useSourceSetup();
  const { name, description, selectedConnection, sourceConfig, flowType } = useELT();

  // Render main content
  const mainContent = (
    <ELTSourceSetup
      onNameChanged={onNameChanged}
      isLoadingInitialData={isLoadingInitialData}
      name={name}
      description={description}
      onDescriptionChanged={onDescriptionChanged}
      formType={FORM_TYPE_CREATE_ELT}
      sourceConfig={sourceConfig}
      selectedConnection={selectedConnection}
      isEditMode={isEditMode}
      templateVersionInfo={templateVersionInfo}
      flowType={flowType}
    />
  );

  // Render SaveConfirmation modal alongside main content
  if (showSaveConfirmation) {
    return (
      <>
        {mainContent}
        <CustomUserConfirmation
          title="Save Changes to Active Source"
          message="You've made changes to an active source. Choose how you want to apply these changes:"
          okButtonLabel="Save for Next Run"
          cancelButtonLabel="Cancel"
          onConfirm={() => handleSaveConfirmation(true)}
          onClose={onCloseSaveConfirmation}
          yesWithChangesButtonLabel="Save & Run Now"
          onRunWithIngestion={() => handleSaveConfirmation(false)}
        />
      </>
    );
  }

  return mainContent;
};

SourceSetupPage.formConfig = {
  title: 'Configure',
};
